import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Paper, useMediaQuery, useTheme } from "@mui/material";
import ConversationList from "./ConversationList";
import ChatThread from "./ChatThread";
import NewConversationDialog from "./NewConversationDialog";

export default function MessagesPage() {
  const { conversationId: paramId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [activeId, setActiveId] = useState(paramId ? Number(paramId) : null);
  const [newDialogOpen, setNewDialogOpen] = useState(false);

  // On mobile, show only one panel at a time
  const showList = !isMobile || !activeId;
  const showThread = !isMobile || !!activeId;

  const handleSelect = (id) => {
    setActiveId(id);
    navigate(`/communication/messages/${id}`, { replace: true });
  };

  const handleNew = () => setNewDialogOpen(true);

  const handleCreated = (id) => {
    setActiveId(id);
    navigate(`/communication/messages/${id}`, { replace: true });
  };

  const handleBack = () => {
    setActiveId(null);
    navigate("/communication/messages", { replace: true });
  };

  return (
    <Box sx={{ height: "calc(100vh - 120px)", display: "flex", minHeight: 0 }}>
      <Paper
        variant="outlined"
        sx={{
          flex: 1,
          display: "flex",
          borderRadius: 2,
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {/* Left: conversation list */}
        {showList && (
          <Box
            sx={{
              width: isMobile ? "100%" : 320,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              borderRight: isMobile ? 0 : 1,
              borderColor: "divider",
              minHeight: 0,
            }}
          >
            <ConversationList
              activeId={activeId}
              onSelect={handleSelect}
              onNew={handleNew}
            />
          </Box>
        )}

        {/* Right: chat thread */}
        {showThread && (
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
            <ChatThread
              conversationId={activeId}
              onBack={isMobile ? handleBack : undefined}
            />
          </Box>
        )}
      </Paper>

      <NewConversationDialog
        open={newDialogOpen}
        onClose={() => setNewDialogOpen(false)}
        onCreated={handleCreated}
      />
    </Box>
  );
}
